export const imageCodes = {
    homeSlider: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban1.jpg?alt=media&token=de79990f-c6a2-4cf0-94e1-ce8754da6398",
    },
    
    new: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnew.png?alt=media&token=331f7694-4b98-452b-923e-76acd1a74111",
    },

    new1: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnew1.png?alt=media&token=afeb1334-344f-477b-a1b7-9ed443b4e5ee",
    },

    new2: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnew2.png?alt=media&token=c6beb0f5-6319-491d-a366-a383094e6187",
    },

    new3: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnew3.png?alt=media&token=f3338b25-dd20-4549-b35b-31135268c8bb",
    },

    new4: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnew4.png?alt=media&token=fb1c18fb-489c-4b5b-9875-285eb124c7f8",
    },

    catego: {
        code: "${merchantId}_tmpl_img_38",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fankel.png?alt=media&token=5dd96673-b82b-4647-96fe-7a8abd2e18d1",
    },

    catego1: {
        code: "${merchantId}_tmpl_img_39",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbracelet.png?alt=media&token=d4422bfc-cdb8-4816-b605-2f271e9b147c",
    },

    catego2: {
        code: "${merchantId}_tmpl_img_40",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcharms.png?alt=media&token=31f7bd4c-ba51-4811-8321-d552ab3f177e",
    },

    catego3: {
        code: "${merchantId}_tmpl_img_41",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fchoker.png?alt=media&token=082edb42-746d-4e97-86ee-c73dfa1e5da9",
    },

    catego4: {
        code: "${merchantId}_tmpl_img_42",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fearrings.png?alt=media&token=e68d0c64-ce81-4a9a-a85a-936c97b14d88",
    },

    catego5: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fdaisy.jpg?alt=media&token=c39c53e2-921b-48a7-96b5-cbabe41e70a6",
    },

    catego6: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fring1.png?alt=media&token=c0020e1a-ce7e-46fe-996d-1cedd6996e68",
    },

    items: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbra.jpg?alt=media&token=2e425042-55bc-46e4-9798-28a889154781"
    },

    items1: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fear.jpg?alt=media&token=7a0d58c0-b84a-4cd3-81af-597e162d555e"
    },

    items2: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fring.jpg?alt=media&token=34862a0c-a4a9-4618-8d42-4d947b2e2c79"
    },

    items3: {
        code: "${merchantId}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ftiny.png?alt=media&token=e162616d-ff61-4fd0-8f57-46fd9a313225"
    },

    items4: {
        code: "${merchantId}_tmpl_img_28",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fstring.png?alt=media&token=eff6ff43-d8e7-4e0e-9028-b11e00a23be6"
    },

    hero: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fher.png?alt=media&token=0ecfa703-35eb-48bc-b4e1-4707e2bfe375"
    },

    limited: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F277529410_487234683078252_7292093700471217463_n.jpg?alt=media&token=e310421a-321e-4817-9b3e-2c1cac747906"
    },

    limited1: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flit1.jpg?alt=media&token=34d4c9bb-addc-447c-8273-fb276d7e089f"
    },

    limited2: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flit2.png?alt=media&token=37ec5938-b49b-4343-9049-c9f6eabf6c14"
    },

    bgimage: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fban.jpg?alt=media&token=0e441977-95f1-471d-b65f-d7da498be01d"
    },

    her: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhers.jpg?alt=media&token=859561a0-f778-4d70-979e-65ef4cfb8dc7"
    },

    her1: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhers1.jpg?alt=media&token=d5f17dcd-211b-47b8-a02e-db067f9207ea"
    },

    her2: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhers2.jpg?alt=media&token=f9cc7b94-b877-4e21-8ce8-9c67912a0fc9"
    },
    
    asteria: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fass.png?alt=media&token=78aa6c1b-3b50-4c49-8266-526fe4837b90"
    },

    littleOdd: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flitoddd1.png?alt=media&token=d4b19e4b-b88d-4bfd-968c-dcdab3e236cb"
    },
    
    yangoods: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fyan1.png?alt=media&token=8b791508-2622-4f20-b8ec-1bcc630f13f9"
    },

    your: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fyour.png?alt=media&token=4f9b21d2-f548-435e-b192-a44805dbdbea"
    },
}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/Xg_CLNeoxAQ"
    }
}

export const textCodes = {
    aboutus: {
        code: "${merchantId}_tmpl_text_1",
        text: "About Her.&Co & Our Products"
    },
}

export const titleCodes = {
    title1: {
        code: "${merchantId}_tmpl_title_1",
        title: "Best Seller Items"
    },

    title2: {
        code: "${merchantId}_tmpl_title_2",
        title: "Limited Collections"
    },

    title3: {
        code: "${merchantId}_tmpl_title_3",
        title: "New Arrivals"
    },

    title4: {
        code: "${merchantId}_tmpl_title_4",
        title: "Hers"
    },

    title5: {
        code: "${merchantId}_tmpl_title_5",
        title: "In collaboration With"
    },

    title8: {
        code: "${merchantId}_tmpl_title_8",
        title: "Categories"
    },

    
}